import { PurchaseOrderRevisionForm } from './validation';

export const ReasonForRequestId = 'revision-reason-for-request';
export const DueDateId = 'revision-due-date';
export const QuantityId = 'revision-quantity';
export const CostId = 'revision-cost';
export const OtherId = 'revision-other';

export type FormId =
  | 'revision-reason-for-request'
  | 'revision-due-date'
  | 'revision-quantity'
  | 'revision-cost'
  | 'revision-other';

export type ErrorList = {
  [key in FormId]: {
    item: FormId;
    index: number | null;
    error: string;
  }[];
};

type PurchaseOrderRevisionFormItem = keyof Pick<
  NonNullable<PurchaseOrderRevisionForm['items']>[0],
  'sizes' | 'prices' | 'comment'
>;

const getItemIdFormatted = (
  itemId: PurchaseOrderRevisionFormItem | undefined,
  item: string,
): FormId => {
  if (itemId === 'sizes') return QuantityId;
  if (itemId === 'prices') return CostId;
  if (itemId === 'comment') return OtherId;
  if (!itemId && item === 'due_date') return DueDateId;
  return ReasonForRequestId;
};

export const getFormIdFromError = (
  error: Record<string, string> | undefined,
): {
  id: FormId | null;
  index: number | null;
} => {
  if (!error) return { id: null, index: null };

  const errorList: ErrorList = {
    [ReasonForRequestId]: [],
    [DueDateId]: [],
    [QuantityId]: [],
    [CostId]: [],
    [OtherId]: [],
  };

  Object.entries(error).forEach(([key, errorMessage]) => {
    const [item, index, itemId] = key.split('.');
    const itemIdFormatted = getItemIdFormatted(
      itemId as PurchaseOrderRevisionFormItem,
      item,
    );

    errorList[itemIdFormatted].push({
      item: item as FormId,
      index: Number(index) >= 0 ? Number(index) : null,
      error: errorMessage,
    });
  });

  if (
    errorList[ReasonForRequestId] &&
    errorList[ReasonForRequestId].length > 0
  ) {
    return { id: ReasonForRequestId, index: null };
  }
  if (errorList[DueDateId] && errorList[DueDateId].length > 0) {
    return { id: DueDateId, index: null };
  }
  if (errorList[QuantityId] && errorList[QuantityId].length > 0) {
    return { id: QuantityId, index: errorList[QuantityId][0].index };
  }
  if (errorList[CostId] && errorList[CostId].length > 0) {
    return { id: CostId, index: errorList[CostId][0].index };
  }
  if (errorList[OtherId] && errorList[OtherId].length > 0) {
    return { id: OtherId, index: errorList[OtherId][0].index };
  }
  return { id: null, index: null };
};
